/* cdds/count_types */
import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'
import _ from 'lodash'

const state = {
    access_isLoading: false,
    access_datasets: {},
    access_data_stack: [],
    params: {},
    access_year: [],
    access_month: [],
    access_ou1: [],
    access_ou2: [],
    access_ou3: [],
    access_ou4: [],
    access_table_data: {},
    main_filters: {},
}

// getters
const getters = {
    access_isLoading: state => {
        return state.access_isLoading
    },
    access_datasets: state => {
        return state.access_datasets
    },
    access_data_stack: state => {
        return state.access_data_stack
    },
    access_params: state => {
        return state.params
    },
    access_year: state => {
        return state.access_year
    },
    access_month: state => {
        return state.access_month
    },
    access_ou1: state => {
        return state.access_ou1
    },
    access_ou2: state => {
        return state.access_ou2
    },
    access_ou3: state => {
        return state.access_ou3
    },
    access_ou4: state => {
        return state.access_ou4
    },
    access_table_data: state => {
        return state.access_table_data
    },
    access_main_filters: state => {
        return state.main_filters
    },
}

// actions
const actions = {
    getAccessOptions(context, payload) {
        // state.access_isLoading = true;
        var _params = {}
        var main_filters = payload.main_filters

        if (main_filters.access_year.selected.value !== '') {
            _params.year = main_filters.access_year.selected.value
        }

        if (main_filters.access_month.selected.value !== '') {
            _params.month = main_filters.access_month.selected.value
        }

        if (main_filters.access_ou1.selected.value !== '') {
            _params.ou1 = main_filters.access_ou1.selected.value
        }

        if (main_filters.access_ou2.selected.value !== '') {
            _params.ou2 = main_filters.access_ou2.selected.value
        }

        if (main_filters.access_ou3.selected.value !== '') {
            _params.ou3 = main_filters.access_ou3.selected.value
        }

        if (main_filters.access_ou4.selected.value !== '') {
            _params.ou4 = main_filters.access_ou4.selected.value
        }

        if (main_filters.system.selected.value !== '') {
            _params.system = main_filters.system.selected.value
        }

        const request = {
            params: qs.parse(_params),
        }

        // query data
        instance
            .get('access_reports/getFilter', request)
            .then(response => {
                payload.stateFilters.forEach(function(stateName) {
                    if (stateName == 'access_options') {
                        state.access_year = response.data.year
                        state.access_month = response.data.month
                        state.access_ou1 = response.data.ou1
                        state.access_ou2 = response.data.ou2
                        state.access_ou3 = response.data.ou3
                        state.access_ou4 = response.data.ou4
                    }
                })
                state.access_isLoading = false
            })
            .catch(error => {
                console.log(
                    error.response,
                    '[store/access_options] syntax errors under instant.get'
                )
            })
    },

    getAccessDataSets(context, payload) {
        state.access_isLoading = true

        var _params = {}
        var main_filters = payload.main_filters

        if (main_filters.access_year.selected.value !== '') {
            _params.year = main_filters.access_year.selected.value
        }

        if (main_filters.access_month.selected.value !== '') {
            _params.month = main_filters.access_month.selected.value
        }

        if (main_filters.access_ou1.selected.value !== '') {
            _params.ou1 = main_filters.access_ou1.selected.value
        }

        if (main_filters.access_ou2.selected.value !== '') {
            _params.ou2 = main_filters.access_ou2.selected.value
        }

        if (main_filters.access_ou3.selected.value !== '') {
            _params.ou3 = main_filters.access_ou3.selected.value
        }

        if (main_filters.access_ou4.selected.value !== '') {
            _params.ou4 = main_filters.access_ou4.selected.value
        }

        if (main_filters.system.selected.value !== '') {
            _params.system = main_filters.system.selected.value
        }

        const request = {
            params: qs.parse(_params),
        }
        state.access_datasets = {}
        // query data
        instance
            .get('access_reports/data', request)
            .then(response => {
                payload.stateDatasets.forEach(function(stateName) {
                    // console.log(response.data);
                    if (stateName == 'access_data') {
                        state.access_datasets = response.data
                        context.commit('OnStateDatasets', payload)
                    }
                })
                state.access_isLoading = false
            })
            .catch(error => {
                console.log(
                    error.response,
                    '[store/access/data] syntax errors under instant.get'
                )
            })
    },

    getAccessTableDataSets(context, payload) {
        state.access_isLoading = true
        state.main_filters = payload.main_filters

        var _params = {}
        var main_filters = payload.main_filters

        if (main_filters.access_year.selected.value !== '') {
            _params.year = main_filters.access_year.selected.value
        }

        if (main_filters.system.selected.value !== '') {
            _params.system = main_filters.system.selected.value
        }

        const request = {
            params: qs.parse(_params),
        }
        state.access_datasets = {}
        // query data
        instance
            .get('access_reports/getTableData', request)
            .then(response => {
                payload.stateDatasets.forEach(function(stateName) {
                    state.access_table_data = response.data
                })
                state.access_isLoading = false
            })
            .catch(error => {
                console.log(
                    error.response,
                    '[store/access/getTableData] syntax errors under instant.get'
                )
            })
    },
}

// mutations
const mutations = {
    CLEAR_DATASETS(state) {
        state.access_datasets = {}
        state.access_table_data = {}
        state.access_data_stack = []
        state.access_ou1 = []
        state.access_ou2 = []
        state.access_ou3 = []
        state.access_ou4 = []
    },
    OnStateDatasets(state, payload) {
        var colors = {}
        var access_datasets = state.access_datasets
        var colors_set = [
            '#ff2391',
            '#ff7b44',
            '#00cebb',
            '#ed1c24',
            '#7030a0',
            '#ffc800',
            '#ff5a00',
            '#235e8a',
            '#3241a6',
            '#578e47',
            '#cf9a41',
            '#be4141',
            '#7d3b98',
            '#7ea632',
            '#32a2a6',
        ]
        var ou = []
        _.map(access_datasets, function(item) {
            return _.map(item.rows, function(item) {
                ou.push(item.ou)
            })
        })

        ou = _.uniq(ou.sort())
        _.forEach(ou, function(item, index) {
            if (index < colors_set.length) {
                colors[item] = colors_set[index]
            } else {
                colors[item] = '#e5e5e5'
            }
        })

        // // --- start dataset for stack chart
        // // items = [{label1:0,label2:0,...,date:string}]
        var items = []
        _.forEach(access_datasets, function(item, index) {
            var _item = {}
            _.forEach(item.rows, function(item, index) {
                _item[item.ou] = item.sum
            })
            _item.country = item.yearmonth
            items.push(_item)
        })

        items = _.sortBy(items, ['country'])

        // // attached colors
        items.push(colors)
        state.access_data_stack = items
        // console.log(access_datasets, state.access_data_stack);
        // --- end dataset for stack chart
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
